import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { Flex } from "antd";
import useLargeListData from "./../../hook/useLargeListData.js";
import MatchCard from "./matchCard/MatchCard";
const MatchCards = ({
  leagues,
  virtualize = true,
  showStartDate = false,
  fixtureClickCallback,
  matchCardClickCallback
}) => {
  const { visibleData } = useLargeListData({ fullData: leagues });
  return /* @__PURE__ */ jsx(Flex, { vertical: true, gap: 16, children: (virtualize ? visibleData : leagues).map((league, index) => /* @__PURE__ */ jsx(
    MatchCard,
    {
      league,
      showStartDate,
      fixtureClickCallback,
      matchCardClickCallback
    },
    index
  )) });
};
var stdin_default = memo(MatchCards);
export {
  stdin_default as default
};
